function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UseCasesService from '@/apps/attributes/services/use_cases_service';
import { mapGetters, mapMutations, mapState } from 'vuex';
import tasks from '@/js/tasks';
export default {
  name: 'AddAttributeGroupComponent',
  props: {
    item: {
      type: Array,
      required: true,
      default: function _default() {
        return {};
      }
    },
    useCaseId: {
      type: Number,
      required: false
    },
    lastVersionId: {
      type: Number,
      required: false
    }
  },
  data: function data() {
    return {
      label: {
        group_name: this.translate('attributes.label.group_name'),
        group_description: this.translate('attributes.label.group_description')
      },
      form: {
        group_description: null,
        group_name: null
      },
      valid: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), mapState('attribute', ['attributes'])), mapGetters('attribute')), {}, {
    rules: function rules() {
      var _this = this;
      return {
        name: [function (v) {
          return !!v || _this.translate('reglas.nombre');
        }, function (v) {
          return v && v.length >= 3 || _this.translate('reglas.nombre_min');
        }, function (v) {
          return v && v.length <= 50 || _this.translate('reglas.nombre_max');
        }],
        description: [function (v) {
          return !!v || _this.translate('reglas.field');
        }, function (v) {
          return v && v.length >= 3 || _this.translate('reglas.nombre_min');
        }, function (v) {
          return v && v.length <= 200 || _this.translate('reglas.nombre_max');
        }]
      };
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations('attribute', ['setAttributes'])), mapMutations('app', ['setShowLoading'])), {}, {
    registerGroup: function registerGroup() {
      var _this2 = this;
      console.log('registerGroup', this.item, "--- useCaseId:", this.useCaseId);
      if (this.item.length < 1 && this.useCaseId === undefined) {
        tasks.toast.error(this.translate('error_messages.not_attributes_selected'));
        return;
      }
      if (this.$refs.form.validate()) {
        this.setShowLoading(true);
        var rDetail = this.item.map(function (item) {
          return {
            attribute_name: item.nombre,
            attribute_object_name: item.tabla,
            attribute_scheme_name: item.dataset,
            attribute_project_name: item.proyecto,
            attribute_category: item.categoria
          };
        });
        var params = {
          prgroup: [{
            preference_group_name: this.form.group_name,
            email: this.userEmail,
            group_description: this.form.group_description,
            usecase_id: this.useCaseId,
            last_version_id: this.lastVersionId
          }],
          pagroup: rDetail
        };
        UseCasesService.createAttributeGroup(this.companyCode, params).then(function (response) {
          // this.setAttributes([])
          tasks.toast.success('Se ha guardado el grupo.');
        }).catch(function (err) {
          console.error(err);
          tasks.toast.error(_this2.translate('error_messages.error_general'), _this2.translate('titles.error'));
        }).finally(function () {
          _this2.setShowLoading(false);
          _this2.$router.push('/attributes/groups');
        });
      }
    },
    translate: function translate(key) {
      return this.$i18n.t(key);
    }
  })
};